import type { BrandName } from './types'

/** 只选择当前品牌；缺失配置由调用方报错，禁止跨品牌回退。 */
export function selectBrandKey(brand: BrandName, keys: readonly string[]): string | undefined {
  return keys.includes(brand) ? brand : undefined
}
